module.exports = __webpack_public_path__ + "ly.svg?7722cf0c5e8564a54ba0e51f290b3962";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ly.svg
// module id = 1311
// module chunks = 27